import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Label, Input, Row, Col } from 'reactstrap';
import CustomSelect from '../../../Base/Common/CustomSelect';
import { getBindingSelectOptions } from '../templateUtils';

class QrCodeInspector extends Component {
    _update = (field, value) => {
        const { element, onChange } = this.props;
        onChange({ ...element, [field]: value });
    };

    render() {
        const { element } = this.props;

        const bindingOptions = [
            { value: null, label: '— Free text —' },
            ...getBindingSelectOptions('qr', element.binding),
        ];

        return (
            <div>
                <Row className="mb-2">
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.Binding" />
                        </Label>
                        <CustomSelect
                            options={bindingOptions}
                            value={bindingOptions.find(o => o.value === element.binding) || bindingOptions[0]}
                            onChange={(opt) => this._update('binding', opt ? opt.value : null)}
                        />
                    </Col>
                </Row>

                {!element.binding && (
                    <Row className="mb-2">
                        <Col>
                            <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                                <FormattedMessage id="TemplateDesigner.Inspector.FreeText" />
                            </Label>
                            <Input
                                type="text"
                                name="freeText"
                                value={element.freeText || ''}
                                placeholder="QR content..."
                                onChange={(e) => this._update('freeText', e.target.value)}
                            />
                        </Col>
                    </Row>
                )}

                <Row className="mb-2">
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.Margin" />
                        </Label>
                        <Input
                            type="number"
                            min={0}
                            max={50}
                            value={element.margin ?? 0}
                            onChange={(e) => this._update('margin', parseFloat(e.target.value) || 0)}
                        />
                    </Col>
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.Colour" />
                        </Label>
                        <Input
                            type="color"
                            value={element.qrColour || '#000000'}
                            onChange={(e) => this._update('qrColour', e.target.value)}
                            style={{ height: '38px', padding: '2px 4px' }}
                        />
                    </Col>
                    <Col>
                        <Label className="mb-1 font-weight-bold" style={{ fontSize: '0.8rem' }}>
                            <FormattedMessage id="TemplateDesigner.Inspector.BgColour" />
                        </Label>
                        <Input
                            type="color"
                            value={element.qrBgColour || '#ffffff'}
                            onChange={(e) => this._update('qrBgColour', e.target.value)}
                            style={{ height: '38px', padding: '2px 4px' }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default QrCodeInspector;
